/* eslint-disable no-unused-vars */
import React, { Component , useRef , useState}  from "react";
import  { Redirect } from 'react-router-dom'

// import  { useRef   }  from "react";
// import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Moment from 'moment';
import validator from 'validator';
import MainLayout from "../layout/main-layout";
import Header from '../layout/Header';
import Left from '../layout/Left';
import DatePicker from "react-datepicker";
import valid from "card-validator";
import "react-datepicker/dist/react-datepicker.css";
import { getPhysician, getPaymentInfo, setStoreRequest,GetPhysicianVialsService,setShippingCost,verifyAddressWithFedex,getFedexShipQuote,getShippingLabel,verifyClientData,getShippingUPSLabel } from '../../actions/payActions'
import { set } from "core-js/core/dict";
import NumberFormat from 'react-number-format';
import Modal from 'react-modal';




class StemCellRequest extends Component {

    constructor(props){
        super(props);
        this.state={
            error:'',
            errors:{},
            formData:{delivery_speed:"Immediate",shipping_method:"",Source:'ACT Physician Portal',minilipo_check:"",minilipo:{name:'Mini Lipo',quantity:0,price:0},shippingLabel:{name:'shipping Label',quantity:0,price:0},shippingLabel_check:"",stemskinserum_check:"",stemskinserum:{name:'Stem Cell Face Serum',quantity:0,price:0},bloodwork:{name:'Bloodwork',quantity:0,price:0},ip:{name:'Initial Processing',quantity:0,price:0},Credit_Card_Billing_Zip_Code:"",amount:0,Payment_Type:"",PaymentMethod:"",CreditCardProcessingFee:0},
            shippindetails:{},
            login:true,                       
            client_test:"",
            client_info:"",
            Dob:'',
            ShipmentDate:"",
            card_last_gid:"",
            card_info:{},
            update_card:false,
            loading:true,
            shipping:0,
            amount:0,
            shipping_info:"false",
            save_card:false,
            verify_client:false,
            Client_id:"",
            Client_lastname:"",
            Infectious_Disease:"",
            shipping_value:"",
            myFutureDate:"",
            myFutureMaxDate:"",
            disableField:false,
            ip:false,
            minilipo:false,
            bloodwork:false,
            stemskinserum:false,
            minilipo_price:0,
            stemskinserum_price:0,
            Services:[],
            amt:"",
            Payment_Type:"",
            update_card:false,
            update_ach:false,
            save_card:false,
            save_ach:false,
            CreditCard:"",
            ShippingLabel:false,
            isOpen:false,
            resetAddress:false,
            city:"",
            state:"",
            zipcode:"",
            street:"",
            showFeedex:false,
            newAddress:{},
            customStyles : {
                content: {
                  top: '50%',
                  left: '50%',
                  right: 'auto',
                  bottom: 'auto',
                  marginRight: '-50%',
                  transform: 'translate(-50%, -50%)',
                },
              },
            // holidayDates: [
            // "09/02/2025","05/26/2025", "05/25/2026", "05/31/2027", "05/29/2028", "05/28/2029", // Memorial Day
            // "07/04/2025", "07/04/2026", "07/04/2027", "07/04/2028", "07/04/2029", // Independence Day
            // "09/01/2025", "09/07/2026", "09/06/2027", "09/04/2028", "09/03/2029", // Labor Day
            // "11/27/2025", "11/26/2026", "11/25/2027", "11/23/2028", "11/22/2029", // Thanksgiving Day
            // "12/25/2025", "12/25/2026", "12/25/2027", "12/25/2028", "12/25/2029", // Christmas Day
            // "01/01/2025", "01/01/2026", "01/01/2027", "01/01/2028", "01/01/2029"  // New Year's Day
            // ],
            holidayDates: [
                "01/01/2026","05/04/2026","05/25/2026","07/04/2026","09/07/2026","11/26/2026","12/25/2026",
                "01/01/2027","03/28/2027","05/31/2027","07/04/2027","09/06/2027","11/25/2027","12/25/2027",
                "01/01/2028","04/16/2028","05/29/2028","07/04/2028","09/04/2028","11/23/2028","12/25/2028",
                "01/01/2029","02/19/2029","05/28/2029","07/04/2029","09/03/2029","11/22/2029","12/25/2029"
              ]


            
        }

        window.addEventListener('storage', (e) => this.add_mini_quantity(e));

        // Bind this to storageChanged()
        this.add_mini_quantity = this.add_mini_quantity.bind(this);
    }

    
  
    componentDidMount() {            
        var physician_id = localStorage.getItem('physician_id'); 
        if(physician_id){
            this.props.getPhysician(physician_id, this.props.history);    
            this.props.getPaymentInfo(physician_id, this.props.history);

            if(this.props.match.params.id){
                var DoseData = localStorage.getItem("DoseData")
                DoseData = JSON.parse(DoseData)
             
                // console.log("DoseData => ",DoseData)
             
                
                this.state.formData['Client_id'] = DoseData.clientACTIdHiddenForDose
                this.setState({Client_id:DoseData.clientACTIdHiddenForDose}) 
                this.state.formData['Client_lastname'] = DoseData.lastName
                this.setState({Client_lastname:DoseData.lastName}) 
                this.state.formData['Longevit_Cells_Availble'] = DoseData.longevityVialsAvailable
                this.state.formData['Free_Bio_Insurance_Cells_Available'] = DoseData.freeBioInsuranceVialsAvailble
            }
            
        }    
        var myCurrentDate=new Date();
        var myFutureDate=new Date(myCurrentDate);
        var myFutureMaxDate=new Date(myCurrentDate);
        myFutureDate.setDate(myFutureDate.getDate()+ 3);
        myFutureMaxDate.setDate(myFutureDate.getDate()+ 9);

        this.setState({myFutureDate:myFutureDate})
        this.setState({myFutureMaxDate:myFutureMaxDate})


         
        var physician_id = localStorage.getItem('physician_id');
        if(physician_id != ""){
            // console.log('imrn')
            this.setState({'physician_id':physician_id})
           
            
        }

        // console.log("param => ",this.props.match.params.id)

        
                
    }

    numberFormat = (value) =>
    new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'USD'
    }).format(value);

   
    helloWord = (e) => {
        console.log('hello');
    }

    checkProcessingfee = (e) =>{
        if(this.state.formData['Payment_Type'] == 'CC'){
          this.state.formData['CreditCardProcessingFee'] = 0.03 * (this.state.amount + this.state.shipping);
          
        }else{
          this.state.formData['CreditCardProcessingFee'] = 0;
      
        }
    }

    savecard = (e) => {
        if(this.state.save_card){
            this.setState({save_card:!this.state.save_card})
            this.state.formData['save_card'] = !this.state.save_card
        }
        else{
            this.setState({save_card:true})

            this.state.formData['save_card'] = true
        }
        console.log(this.state.formData);
    }

    saveAch = (e) => {
        if(this.state.save_ach){
            this.setState({save_ach:!this.state.save_ach})
            this.state.formData['save_ach'] = !this.state.save_ach
        }
        else{
            this.setState({save_ach:true})

            this.state.formData['save_ach'] = true
        }

        console.log('save_Ach ', this.state.save_ach);
    }


    onChange = (e) =>{     
        
         if(e.target.id == "shipping_method" || e.target.id == "ShippingLabelType"){
            
            if(e.target.value=="FedEx"){
                this.setState({shipping:0})
                this.state.formData['amount'] = this.state.amount+ 0;
            }
           
            this.state.formData[e.target.id] = e.target.value;
            this.state.formData['shipping_method'] = e.target.value;

            if(!this.state.formData['minilipo_check'] && !this.state.ip && !this.state.bloodwork){
                var myCurrentDate=new Date();
                var myFutureDate=new Date(myCurrentDate);
                var myFutureMaxDate=new Date(myCurrentDate);
                this.setState({myFutureDate:myFutureDate})
            }
 
        }             
        else if(e.target.id == "Client_id"){
            this.state.formData[e.target.id] = e.target.value;
            this.setState({Client_id:e.target.value})
        }
        else if(e.target.id == "Client_lastname"){
            this.state.formData[e.target.id] = e.target.value;
            this.setState({Client_lastname:e.target.value})
        }
        else if(e.target.id == "Credit_Card_Holder_Zip"){
            this.state.formData['Credit_Card_Billing_Zip_Code'] = e.target.value;
           
        }
        else if( e.target.id == "saveAddressForFuture"){
            var checked = e.target.checked ? true:false;
    
                this.setState({saveAddressForFuture: checked})
                this.state.formData['saveAddressForFuture'] = checked;
        }
        else{
            this.state.formData[e.target.id] = e.target.value; 
            var a = e.target.id;
            this.setState({formData:{ ...this.state.formData,a:e.target.value}})
          

        }      
        console.log('form data => ',this.state.formData);
    }

    checkRadio3 = (e) => {     
        if(this.state.update_card){
            this.setState({update_card:!this.state.update_card})
            this.state.formData["Credit_Card_Number"] = this.state.card_info['Credit_Card_Number']
            this.state.formData["CVV"] = this.state.card_info['CVV']
            this.state.formData["Credit_Card_Holder_First_Name"] = this.state.card_info['Credit_Card_Holder_First_Name']
            this.state.formData["Credit_Card_Holder_Last_Name"] = this.state.card_info['Credit_Card_Holder_Last_Name']
            this.state.formData["Month_of_Expiry"] = this.state.card_info['Month_of_Expiry']
            this.state.formData["Year_of_Expiry"] = this.state.card_info['Year_of_Expiry']
            
        }
        else{
            this.state.formData["Credit_Card_Number"] = ""
            this.state.formData["CVV"] = ""
            this.state.formData['Credit_Card_Holder_First_Name'] = ""
            this.state.formData['Credit_Card_Holder_Last_Name'] = ""
            this.state.formData['Month_of_Expiry'] = ""
            this.state.formData['Year_of_Expiry'] = ""
            
            

            this.setState({update_card:true})
        }
        
        console.log('update_card =>', this.state.update_card)
        console.log('form data  =>', this.state.formData)
    }

    componentWillReceiveProps(nextProps) {
        console.log('nextProps ----------',nextProps); 

        if(nextProps.page_name.pay_info && this.state.update_card==false){
            this.state.formData['Credit_Card_Holder_First_Name'] = nextProps.page_name.pay_info.Credit_Card_Holder_First_Name__c
            this.state.formData['Credit_Card_Holder_Last_Name'] = nextProps.page_name.pay_info.Credit_Card_Holder_Last_Name__c
            this.state.formData['Credit_Card_Billing_Zip_Code'] = nextProps.page_name.pay_info.Credit_Card_Billing_Zip_Code__c
            this.state.formData['CVV'] = nextProps.page_name.pay_info.CVV__c
            this.state.formData['Credit_Card_Number'] = nextProps.page_name.pay_info.Credit_Card_Number__c
            this.state.formData['Month_of_Expiry'] = nextProps.page_name.pay_info.Month_of_Expiry__c
            this.state.formData['Year_of_Expiry'] = nextProps.page_name.pay_info.Year_of_Expiry__c
           
            this.state.formData['PhysicianFirstName'] = nextProps.page_name.pay_info.FirstName
            this.state.formData['PhysicianLastName'] = nextProps.page_name.pay_info.LastName

            
            this.setState({Credit_Card_Number:nextProps.page_name.pay_info.Credit_Card_Number__c})
            // this.setState({card_info:nextProps.page_name.pay_info})
            this.state.card_info['Credit_Card_Number'] = nextProps.page_name.pay_info.Credit_Card_Number__c
            this.state.card_info['CVV'] = nextProps.page_name.pay_info.CVV__c
            this.state.card_info['Credit_Card_Holder_First_Name'] = nextProps.page_name.pay_info.Credit_Card_Holder_First_Name__c
            this.state.card_info['Credit_Card_Holder_Last_Name'] = nextProps.page_name.pay_info.Credit_Card_Holder_Last_Name__c
            this.state.card_info['Month_of_Expiry'] = nextProps.page_name.pay_info.Month_of_Expiry__c
            this.state.card_info['Year_of_Expiry'] = nextProps.page_name.pay_info.Year_of_Expiry__c
            this.state.card_info['PhysicianFirstName'] = nextProps.page_name.pay_info.FirstName
            this.state.card_info['PhysicianLastName'] = nextProps.page_name.pay_info.LastName
            this.state.card_info['ABA_Routing_Number'] = nextProps.page_name.pay_info.ABA_Routing_Number__c
            this.state.card_info['Name_On_Account'] = nextProps.page_name.pay_info.Name_on_ACH_Account__c
            this.state.card_info['Account_Number'] = nextProps.page_name.pay_info.Account_Number__c




            if(nextProps.page_name.pay_info.Account_Number__c){
                var acc_num = nextProps.page_name.pay_info.Account_Number__c;
                this.state.acc_num = acc_num.slice(acc_num.length - 4)
                this.state.formData['Account_Number'] = nextProps.page_name.pay_info.Account_Number__c
            }

            if(nextProps.page_name.pay_info.ABA_Routing_Number__c){
                this.state.formData['ABA_Routing_Number'] = nextProps.page_name.pay_info.ABA_Routing_Number__c
            }
            
            if(nextProps.page_name.pay_info.Name_on_ACH_Account__c){
                this.state.formData['Name_On_Account'] = nextProps.page_name.pay_info.Name_on_ACH_Account__c
            }

            if(nextProps.page_name.pay_info.Credit_Card_Number__c){
                var nu =  nextProps.page_name.pay_info.Credit_Card_Number__c
                this.state.card_last_gid = nu.slice(nu.length - 4)
            }
            this.setState({loading:false})


          } 
        if(nextProps.page_name.page_name && this.state.ShippingLabel == false ){
            this.state.formData['PhysicianId'] = nextProps.page_name.page_name.Id
            this.state.formData['Id'] = nextProps.page_name.page_name.Physician_ID__c
            this.state.formData['PhysicianLastName'] = nextProps.page_name.page_name.LastName 
            this.state.shippindetails['LastName'] = nextProps.page_name.page_name.LastName 
            this.state.shippindetails['FirstName'] = nextProps.page_name.page_name.FirstName 
            this.state.shippindetails['Phone'] = nextProps.page_name.page_name.Phone 
            this.state.shippindetails['Street'] = nextProps.page_name.page_name.MailingStreet 
            this.state.shippindetails['City'] = nextProps.page_name.page_name.MailingCity
            this.state.shippindetails['State'] = nextProps.page_name.page_name.MailingState
            this.state.shippindetails['Country'] = nextProps.page_name.page_name.MailingCountry
            this.state.shippindetails['ZipCode'] = nextProps.page_name.page_name.MailingPostalCode
            this.state.shippindetails['Credit_Card_Billing_Email'] = nextProps.page_name.page_name.Email
            this.setState({loading:false})
            this.state.formData['FirstName'] = this.state.shippindetails['FirstName'] 
            this.state.formData['LastName'] = this.state.shippindetails['LastName'] 
            this.state.formData['Street'] = this.state.shippindetails['Street']
            this.state.formData['City'] = this.state.shippindetails['City']
            this.state.formData['State'] = this.state.shippindetails['State']
            this.state.formData['Country'] = this.state.shippindetails['Country']
            this.state.formData['ZipCode'] = this.state.shippindetails['ZipCode']
            this.state.formData['Phone'] = this.state.shippindetails['Phone']
            this.state.formData['ShippingEmail'] = nextProps.page_name.page_name.Shipping_Email__c


            if(this.state.shippindetails['Phone'] == "" || this.state.shippindetails['Phone'] == null ){
                this.state.formData['Phone'] = '8444432355';
            }
        }        

        if(nextProps.page_name.payment_info){
            this.setState({loading:false})
            this.setState({payment_response:nextProps.page_name.payment_info.page_name})
            this.setState({transaction_id:nextProps.page_name.payment_info.TransactionId})
            this.setState({api_error:nextProps.page_name.payment_info.error})
            this.setState({loading:false})
        }

        if(nextProps.page_name.request_info){
            this.setState({loading:false})
            if(nextProps.page_name.request_info.error){
                this.setState({api_error:nextProps.page_name.request_info.error})
            }else{
                this.setState({payment_response:nextProps.page_name.request_info})
            }
            
            
        }

        if(nextProps.page_name.client_info){
            this.setState({loading:false})
            var re = JSON.parse(nextProps.page_name.client_info)
            // console.log('response -----------------=> ',re);
            if(re.error != null){
                let errors = {};
                document.getElementById("Client_id").value = ""; 
                document.getElementById("Client_lastname").value = "";                               
                this.state.formData['Client_id']="";
                this.state.formData['Client_lastname']="";
                errors["Client_id"] = "Please enter valid Client ID or last name";
              
                this.setState({errors: errors});
            }else{
                this.setState({verify_client:true})
                this.setState({paid_date:true});
                let errors = {};


                
                this.state.formData['AnnualBankingPrepaidUntil'] = re.AnnualBankingPrepaidUntil;
                this.setState({client_success_msg:"Client Details Successfully Confirmed"});  
                this.state.formData['clientConsentFormCompleted'] = re.clientConsentFormCompleted;

            }     
            
        }


        if(nextProps.page_name.verify_Address){

            var verifyAdd = nextProps.page_name.verify_Address;
            if(verifyAdd.name == "Error"){
                this.setState({'ShippingLabel':false});
                this.state.errors["ShippingLabel"] = 'There is some issue processing the label for this address.'
            }
            else{
                if(verifyAdd.output.resolvedAddresses){
           
            this.state.errors["ShippingLabel"] =""
                    this.setState({'newAddress': verifyAdd.output.resolvedAddresses[0]});
                }
            }
            

        }

        if(nextProps.page_name.ship_label){

            this.setState({loading:false})

            const shipData = nextProps.page_name.ship_label;

            if(shipData.name &&  shipData.name == "Error"){
            this.setState({'ShippingLabel':false});
            this.state.errors["ShippingLabel"] = 'There is some issue processing the label for this address. Kindly reprocess the form without selecting label'
            this.state.success_msg = '';
            this.state.formData['ShippingAmount'] = 0


            }else{
             console.log(' shipping----------',shipData.output.transactionShipments[0].masterTrackingNumber )

                this.state.formData['masterTrackingNumber'] = shipData.output.transactionShipments[0].masterTrackingNumber;
                // this.state.formData['lableLink'] = shipData.transactionShipments[0].shipmentDocuments[0].url;
                // this.state.formData['ShippingAmount'] = shipData.output.transactionShipments[0].completedShipmentDetail.shipmentRating.shipmentRateDetails[0].totalNetFedExCharge;
                var shi_amt = shipData.output.transactionShipments[0].completedShipmentDetail.shipmentRating.shipmentRateDetails[0].totalNetFedExCharge;
                this.state.formData['ShippingAmount'] = shi_amt + (shi_amt * 0.2);
                this.state.shipping = shi_amt + (shi_amt * 0.2);
                this.state.formData['LabelBlob'] = shipData.output.transactionShipments[0].pieceResponses[0].packageDocuments[0].encodedLabel;

                if(this.state.formData['ShippingAmount'] <= 50){
                    this.state.formData['ShippingAmount'] = 50;
                    this.state.shipping = 50;
                }
                this.state.success_msg = 'Pickup Confirmed';
                this.state.success_fedexmsg = 'Address Successfully Verified'

                this.state.errors["ShippingLabel"] = ''
                this.state.formData['shippingLabel']['price'] = this.state.formData['ShippingAmount'];
                // this.state.formData['shippingLabel']['price'] = this.state.formData['ShippingAmount'];
            }

           



        }

        if(nextProps.page_name.ups_label){

            this.setState({loading:false})

            const shipData = nextProps.page_name.ups_label;

            if(shipData.response){
            this.setState({'ShippingLabel':false});
            this.state.errors["ShippingLabel"] = 'There is some issue processing the label for this address. Kindly reprocess the form without selecting label'
            this.state.success_msg = '';
            this.state.formData['ShippingAmount'] = 0


            }else{
             console.log(' ups----------',shipData);
              var label = shipData.ShipmentResponse.ShipmentResults.PackageResults[0].ShippingLabel.GraphicImage;
          //   console.log(' label----------',label);

             console.log('ppp---- ',shipData.ShipmentResponse.ShipmentResults.NegotiatedRateCharges.TotalCharge);

              var shi_amt = parseFloat(shipData.ShipmentResponse.ShipmentResults.NegotiatedRateCharges.TotalCharge.MonetaryValue);
              var masterTrackingNumber = shipData.ShipmentResponse.ShipmentResults.ShipmentIdentificationNumber;
             console.log(' shi_amt----------',shi_amt);

              this.state.formData['LabelBlob'] = label;
              this.state.formData['masterTrackingNumber'] = masterTrackingNumber;
              this.state.formData['ShippingAmount'] = shi_amt + (shi_amt * 0.2);
              this.state.shipping = shi_amt + (shi_amt * 0.2);
                if(this.state.formData['ShippingAmount'] <= 50){
                    this.state.formData['ShippingAmount'] = 50;
                    this.state.shipping = 50;

                    this.setState({shipping : 50});
                }
                this.state.success_msg = 'Pickup Confirmed';
                this.state.errors["ShippingLabel"] = '';
                this.state.success_msg = 'Pickup Confirmed';
                this.state.success_fedexmsg = 'Address Successfully Verified'
            }

           console.log('ShippingAmount ----------- ',this.state.formData['ShippingAmount'])



        }


        if(nextProps.page_name.ship_quote){

            var quote = nextProps.page_name.ship_quote;

            if(quote.name == "Error"){
                this.setState({'ShippingLabel':false});
                this.state.errors["ShippingLabel"] = 'There is some issue processing the label for this address. Please choose a different address or ACT VIP service to proceed with the order.'
                this.state.success_fedexmsg = '';
            }
            else{
                if(quote.output.rateReplyDetails[1].ratedShipmentDetails[0].totalNetCharge){
                    var shi_amt = quote.output.rateReplyDetails[1].ratedShipmentDetails[0].totalNetCharge;
                    this.state.formData['ShippingFeeCharged'] = shi_amt + (shi_amt * 0.2);
                    this.state.shipping = shi_amt + (shi_amt * 0.2);
                    this.setState({shipping : shi_amt + (shi_amt * 0.2)});
                    // this.state.shipping = shi_amt + (shi_amt * 0.2);
                    this.state.errors["ShippingLabel"] = ""
                    console.log('ship amt ------- ',this.state.formData['ShippingFeeCharged'])
                    console.log('ship amt ------- ',shi_amt)
                    if(this.state.formData['ShippingFeeCharged'] <= 50){
                        this.state.formData['ShippingFeeCharged'] = 50;
                    this.state.shipping = 50;

                    this.setState({shipping : 50});
    
                    }
                    this.state.success_fedexmsg = 'Address Successfully Verified'
                this.state.errors["ShippingLabel"] = ''
                
                this.state.total_amount = this.state.amount + this.state.formData['ShippingFeeCharged'] + this.state.cpp_price;

                    // this.state.formData['amount'] = this.state.formData['AmountForDoseCharged'] + this.state.shipping+ this.state.formData['CPPAmountCharged'];

    
                }
            }
            

        }

       
    }

    subtractOneDay = (date) => {
        return Moment(date).subtract(1, "days").format("MM/DD/YYYY");
      };

    datechange1(e){
        // new Date(e);
        this.state.formData['ShipmentDate'] = Moment(e).format('MM/DD/YYYY');
        // console.log('selected date =>', this.state.formData['ShipmentDate']);
        var newHolidayDate = this.subtractOneDay(this.state.formData['ShipmentDate']);

        var selected_day = Moment(e).day();
        let errors = {};
        const yOffset = -80;
        let formIsValid = true;
        if(this.state.formData['shipping_method']=="FedEx"){
            // console.log('selected day before =>', selected_day );
            if(selected_day == 1 || selected_day == 0){
                // console.log('selected day =>', Moment(e).day() );               
                errors["ShipmentDate"] = "FedEx does not deliver on Sunday and Monday. Please choose a different date from Tuesday to Saturday for shipment arrival";
                let element = document.getElementById("ShipmentDate");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
                
                formIsValid = false;
            }
            else if(this.state.holidayDates.includes(newHolidayDate) ){
                // console.log('selected day =>', Moment(e).day() );
                
                errors["ShipmentDate"] = "FedEx does not deliver on Holidays. Please choose a different date from holiday for shipment arrival.";
                let element = document.getElementById("ShipmentDate");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
                formIsValid = false;
               // this.state.formData['ShipmentDate'] = "";
              
            }
            else if(this.state.holidayDates.includes(this.state.formData['ShipmentDate']) ){
                // console.log('selected day =>', Moment(e).day() );
                
                errors["ShipmentDate"] = "FedEx does not deliver on Holidays. Please choose a different date from holiday for shipment arrival.";
                let element = document.getElementById("ShipmentDate");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
                formIsValid = false;
               // this.state.formData['ShipmentDate'] = "";
              
            }
            else{
                errors["ShipmentDate"] = "";
                formIsValid = true;
                
            }
            this.setState({errors: errors});
        }
        else{
            errors["ShipmentDate"] = "";
            // this.state.error["ShipmentDate"] = "";
            formIsValid = true;
            // alert('okay');
            
        }

        this.setState({ShipmentDate:e})
    }

    UseShipping =(e) => {
        var checked = e.target.checked ? "True":"False";
        this.setState({shipping_value:e.target.value})
        if(e.target.value=="yes"){
            this.setState({shipping_info:checked})
            this.state.formData['ShippingInfo'] = checked;
            this.state.formData['FirstName'] = this.state.shippindetails['FirstName'] 
            this.state.formData['LastName'] = this.state.shippindetails['LastName'] 
            this.state.formData['Street'] = this.state.shippindetails['Street']
            this.state.formData['City'] = this.state.shippindetails['City']
            this.state.formData['State'] = this.state.shippindetails['State']
            this.state.formData['Country'] = this.state.shippindetails['Country']
            this.state.formData['ZipCode'] = this.state.shippindetails['ZipCode']
            this.state.formData['Phone'] = this.state.shippindetails['Phone']

            if(this.state.shippindetails['Phone'] == "" || this.state.shippindetails['Phone'] == null ){
                this.state.formData['Phone'] = '8444432355';
            }
            
            
            // console.log("checked ", this.state.formData)
        }else{
            this.setState({shipping_info:checked})
            this.state.formData['ShippingInfo'] = checked;
            this.state.formData['FirstName'] = "" 
            this.state.formData['LastName'] = "" 
            this.state.formData['Street'] = ""
            this.state.formData['City'] = ""
            this.state.formData['State'] = ""
            this.state.formData['Country'] = ""
            this.state.formData['ZipCode'] = ""
            this.state.formData['Phone'] = ""
           
        }

        console.log(this.state.formData);
       
    }


    findShipping =(e)=>{
        var newList = {zip:'302029'};
        this.props.setShippingCost(newList, this.props.history);
    }


    countKits = (e) => {

        var count = e.target.value;
        var amt;
        
        if(e.target.id == 'minilipo_kits'){

            // this.state.formData['mini-lipo-kit'] = count;
            if(count > 5){
                amt = 200 * count;
                // this.state.formData['mini-lipo-price'] = amt;
                this.state.formData['minilipo']['quantity'] = count;
                this.state.formData['minilipo']['price'] = amt;

                
                this.setState({amt:amt})
                this.setState({minilipo_price:amt})
                this.setState({amount:amt})

                this.state.formData['Amount'] = amt;
                
                // this.state.minilipo_price = amt;
            }else{
                amt = 250 * count;
                // this.state.formData['mini-lipo-price'] = amt;                
                this.state.formData['minilipo']['quantity'] = count;
                this.state.formData['minilipo']['price'] = amt;
                this.setState({amt:amt});
                this.setState({amount:amt});
                this.state.formData['Amount'] = amt;


                // this.state.minilipo_price = amt;
                // this.setState({minilipo_price:amt})
            }

        }

        if(e.target.id == 'ips_kits'){
            amt = 0 * count;
            this.state.formData['ips']['quantity'] = count;
            this.state.formData['ips']['price'] = amt;
            this.setState({amt:amt})

        
        }

        if(e.target.id == 'bloodwork_kits'){
            amt = 0 * count;
            this.state.formData['bloodwork']['quantity'] = count;
            this.state.formData['bloodwork']['price'] = amt;   
            this.setState({amt:amt})

        }
       
            
           
       
            // console.log('min price ------- ', this.state.minilipo_price);
            console.log('min price form ------- ', this.state.formData);
    }

    checkAch = (e) => {
        this.setState({update_ach:!this.state.update_ach})
        

        if(this.state.update_ach){
            this.state.formData["Account_Number"] = this.state.card_info['Account_Number']
            this.state.formData["Name_On_Account"] = this.state.card_info['Name_On_Account']
            this.state.formData["ABA_Routing_Number"] = this.state.card_info['ABA_Routing_Number']
        }else{
            this.state.formData["Account_Number"] = ""
            this.state.formData["Name_On_Account"] = ""
            this.state.formData["ABA_Routing_Number"] = ""
            // this.setState({update_ach:true})

        }
        console.log('update_card =>', this.state.update_ach)


    }


    check_quantity = (e) => {

         
        var count = e.target.value;

        if(isNaN(count)){
            e.target.value = 0;
            console.log('ip value --',e.target.value);
        }

    }

    add_mini_quantity = (e) => {

                
            let count = this.state.formData['minilipo']['quantity'];
            let amt;
           
            if(isNaN(count)){
                count = 0;
            }else{
                count = count+1;
                // count = parseInt(element.value);
            }


            var myCurrentDate=new Date();
        var myFutureDate=new Date(myCurrentDate);
        var myFutureMaxDate=new Date(myCurrentDate);
        myFutureDate.setDate(myFutureDate.getDate()+ 3);
        myFutureMaxDate.setDate(myFutureDate.getDate()+ 9);

        this.setState({myFutureDate:myFutureDate})
        this.setState({myFutureMaxDate:myFutureMaxDate})
            
          
            // console.log('count before ---------------- ',element.value);
            if(count >= 5){
                amt = 200 * count;

                            
                this.state.formData['mini-lipo-price'] = amt;
                this.state.formData['minilipo']['quantity'] = count;
                this.state.formData['minilipo']['price'] = amt;
                this.state.formData['minilipo_check'] = "true";
                
                
                
                this.state.minilipo_price = amt;
                this.state.amt = amt;
                this.state.amount = this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];       
                this.state.minilipo = true;    
                
                this.state.formData['amount'] = amt + this.state.formData['stemskinserum']['price'];            


                

                this.setState({
                    minilipo: true,
                    minilipo_price: amt,
                    formData: this.state.formData
                 })
                         
              
            }else{
                amt = 250 * count;
                this.state.formData['mini-lipo-price'] = amt;                 
            
                this.state.formData['minilipo']['quantity'] = count;
                this.state.formData['minilipo']['price'] = amt;
                this.state.formData['minilipo_check'] = "true";

                this.state.minilipo_price = amt;
                this.state.amt = amt;
                this.state.amount = amt +  this.state.formData['stemskinserum']['price'];
                this.state.formData['amount'] = amt + this.state.formData['stemskinserum']['price'];            

                
                this.setState({
                    minilipo: true,
                    minilipo_price: amt,
                    formData: this.state.formData
                 })

              
            }

            this.state.formData['StoreFee'] = this.state.formData['amount'];

            // console.log(amt);
            console.log('count ---------------- ',count);
            this.checkProcessingfee();
            this.helloWord();
    
    }

    add_quantity = (e) => {
       
        // e.preventDefault();  
        if(e.target.name == 'ip'){
            // let element = document.getElementById("ip_quantity");
            let count =  this.state.formData['ip']['quantity'];
            let amt;
            if(isNaN(count)){
                count = 0;
            }else{
                count = count+1;
                // count = parseInt(element.value);
            }

            var myCurrentDate=new Date();
        var myFutureDate=new Date(myCurrentDate);
        var myFutureMaxDate=new Date(myCurrentDate);
        myFutureDate.setDate(myFutureDate.getDate()+ 3);
        myFutureMaxDate.setDate(myFutureDate.getDate()+ 9);

        this.setState({myFutureDate:myFutureDate})
        this.setState({myFutureMaxDate:myFutureMaxDate})

            amt = 0 * count;
            
                        
            this.state.formData['ip']['quantity'] = count;
            this.state.formData['ip']['price'] = amt;
            this.state.amt = amt;
            this.state.amount =  amt + this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];
            this.state.formData['amount'] = amt + this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];                 


            this.setState({           
                ip: true,
                formData: this.state.formData
             })
            


        }

        if(e.target.name == 'bloodwork'){
            // let element = document.getElementById("bloodwork");
            let count = this.state.formData['bloodwork']['quantity'];
            let amt = 0;
            if(isNaN(count)){
                count = 0;
            }else{
                count = count+1;
                // count = parseInt(element.value);
            }
            amt = 0 * count;
            
                        
            this.state.formData['bloodwork']['quantity'] = count;
            this.state.formData['bloodwork']['price'] = amt;
            this.state.amt = amt;
            this.state.amount = amt + this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];
            this.state.formData['amount'] = amt + this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];                 


            this.setState({
                bloodwork: true,
                formData: this.state.formData
             })
                 
            
                      
        }

        if(e.target.name == 'stemskinserum'){
            let count = this.state.formData['stemskinserum']['quantity'];
            let amt;
           
            if(isNaN(count)){
                count = 0;
            }else{
                count = count+1;
                // count = parseInt(element.value);
            }

            if(count >= 11){
                amt = 150 * count;

                            
                this.state.formData['stemskinserum-price'] = amt;
                this.state.formData['stemskinserum']['quantity'] = count;
                this.state.formData['stemskinserum']['price'] = amt;
                this.state.formData['stemskinserum_check'] = "true";
                this.state.formData['amount'] = this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];                 

                
                
                this.state.stemskinserum_price = amt;
                this.state.amt = amt
                this.state.amount = this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];       
                this.state.stemskinserum = true;       

                this.setState({
                    stemskinserum: true,
                    stemskinserum_price: this.state.formData['mini-lipo-price'],
                    formData: this.state.formData
                 })
                         
              
            }else{
                amt = 175 * count;
                this.state.formData['stemskinserum-price'] = amt;
                this.state.formData['stemskinserum']['quantity'] = count;
                this.state.formData['stemskinserum']['price'] = amt;
                this.state.formData['stemskinserum_check'] = "true";
                this.state.formData['amount'] = this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];  

                this.state.amt = amt;
                this.state.amount = this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];
                this.state.stemskinserum = true;   
                
                this.setState({
                    stemskinserum: true,
                    stemskinserum_price: amt,
                    formData: this.state.formData
                 })

              
            }
        }

        if(e.target.name == 'shippingLabel'){

            let count =  this.state.formData['shippingLabel']['quantity'];
            let amt;
            if(isNaN(count)){
                count = 0;
            }
            else if(count == 1){
                count = 1;

            }else{
                count = count+1;
                // count = parseInt(element.value);
            }

            if(count ==1){
                this.setState({showFeedex:true});
            // this.setState({'ShippingLabel':true});

                // this.setState({shipping:50})

                // this.state.shipping = 50;
            }

            amt = 0 * count;
            this.state.formData['shippingLabel_check'] = "true";
            
                        
            this.state.formData['shippingLabel']['quantity'] = count;
            this.state.formData['shippingLabel']['price'] = amt;
            this.state.amt = amt;
            this.state.amount =  amt + this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];
            this.state.formData['amount'] = amt + this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];                 


            this.setState({           
                shippingLabel: true,
                formData: this.state.formData
             })

        }
        this.state.formData['StoreFee'] = this.state.formData['amount'];

        this.checkProcessingfee();


      

        // console.log('ccccc-------',)

        console.log(this.state.formData);
           

    }

    remove_quantity = (e) => {
        if(e.target.name == 'bloodwork'){
            let element = document.getElementById("bloodwork");
            let count = this.state.formData['bloodwork']['quantity'];
            let amt;
            if(isNaN(count)){
                count = 0;
            }else if(count > 0 ){           
                count -= 1;
                if(count == 0){
                    this.setState({
                       ip: false,
                       formData: this.state.formData
                    })
               }
            }
            else if(count == 0){
                this.setState({
                    bloodwork: false,
                 })
            }
           
                amt = 0 * count;
            
                        
                this.state.formData['bloodwork']['quantity'] = count;
                this.state.formData['bloodwork']['price'] = amt;
                this.state.amt = amt;
                this.state.amount = amt + this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];
                this.setState({
                    formData: this.state.formData
                 })
        }

        if(e.target.name == 'mini-lipo'){
            let element = document.getElementById("mini-lipo");
            let count = this.state.formData['minilipo']['quantity'];
            let amt;
            if(isNaN(count)){
                count = 0;
                this.state.formData['minilipo_check'] = "";
                this.state.minilipo = false;
            }else if(count >= 1 ){           
                count -= 1;
                if(count == 0){
                    this.state.formData['minilipo_check'] = "";
                    this.setState({
                        minilipo: false,
                        formData: this.state.formData
                     })
                }
            }else if(count == 0){
                this.state.formData['minilipo_check'] = "";
                this.setState({
                    minilipo: false,
                    formData: this.state.formData
                 })
            }

            if(count >= 5){
                amt = 200 * count;
            }else{
                amt = 250 * count;

            }
            this.state.formData['mini-lipo-price'] = amt;   

                this.state.formData['minilipo']['quantity'] = count;
                this.state.formData['minilipo']['price'] = amt;
                this.state.amt = amt;
                this.state.amount = this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];
                this.state.formData['amount'] = this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];                 

                this.setState({                    
                    minilipo_price: amt,
                    formData: this.state.formData
                 })
        }

        if(e.target.name == 'ip'){
            // let element = document.getElementById("ip_quantity");
            let count = this.state.formData['ip']['quantity'];
            let amt;
            if(isNaN(count)){
                count= 0;              

            }else if(count > 0 ){           
                count -= 1;
                if(count == 0){
                     this.setState({
                        ip: false,
                        formData: this.state.formData
                     })
                }
                // count = parseInt(element.value);
            }else if(count == 0){
                this.setState({
                    ip: false,
                 })
            }

            amt = 0 * count;
            
                        
            this.state.formData['ip']['quantity'] = count;
            this.state.formData['ip']['price'] = amt;
            this.state.amt = amt;
            this.state.amount = amt + this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];

            this.setState({                    
                formData: this.state.formData
             })
        }

        if(e.target.name == 'shippingLabel'){
            let count = this.state.formData['shippingLabel']['quantity'];
            let amt;
            if(isNaN(count)){
                count= 0;              

            }else if(count > 0 ){           
                count -= 1;
                if(count == 0){
                     this.setState({
                        shippingLabel: false,
                        formData: this.state.formData
                     })
                this.setState({showFeedex:false});
                

                }
                // count = parseInt(element.value);
            }else if(count == 0){
                this.setState({
                    shippingLabel: false,
                 })
                this.setState({showFeedex:false});
            this.setState({'ShippingLabel':false});

                this.setState({shipping:0})
                this.state.shipping = 0;

            }

            amt = 0 * count;
            this.state.shipping = 0;
            this.setState({shipping:0})
            this.setState({
                shippingLabel: false,
             })
            
             
             this.state.formData['shippingLabel_check'] = "";

            this.state.formData['shippingLabel']['quantity'] = count;
            this.state.formData['shippingLabel']['price'] = amt;
            this.state.amt = amt;
            this.state.amount = amt + this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];

            this.setState({                    
                formData: this.state.formData
             })
        }

        if(e.target.name == 'stemskinserum'){
            let element = document.getElementById("stemskinserum");
            let count = this.state.formData['stemskinserum']['quantity'];
            let amt;
            if(isNaN(count)){
                count = 0;
                this.state.formData['stemskinserum_check'] = "";
                this.state.stemskinserum = false;
            }else if(count >= 1 ){           
                count -= 1;
                if(count == 0){
                    this.state.formData['stemskinserum_check'] = "";
                    this.setState({
                        stemskinserum: false,
                        formData: this.state.formData
                     })
                }
            }else if(count == 0){
                this.state.formData['stemskinserum_check'] = "";
                this.setState({
                    stemskinserum: false,
                    formData: this.state.formData
                 })
            }

            if(count >= 10){
                amt = 150 * count;
            }else{
                amt = 175 * count;

            }
            this.state.formData['stemskinserum-price'] = amt;   

                this.state.formData['stemskinserum']['quantity'] = count;
                this.state.formData['stemskinserum']['price'] = amt;
                this.state.amt = amt
                this.state.amount = this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];
                this.state.formData['amount'] = this.state.formData['minilipo']['price']+  this.state.formData['stemskinserum']['price'];                 

                this.setState({                    
                    stemskinserum_price: amt,
                    formData: this.state.formData
                 })
        }
        this.state.formData['StoreFee'] = this.state.formData['amount'];

        this.checkProcessingfee();

        console.log('remove -------', this.state.formData);

    }

    

    checkPayment = (e) => {
        if(e.target.id == "credit_card"){
            this.state.formData['CreditCard'] = true; 
            this.setState({CreditCard:e.target.value})
            
            // this.state.formData['PaymentMethod'] = 'Credit Card';
            this.state.formData['PaymentMethod'] = 'Credit Card';
            this.state.formData["Credit_Card_Number"] = this.state.card_info['Credit_Card_Number']
            this.state.formData["CVV"] = this.state.card_info['CVV']
            this.state.formData["Credit_Card_Holder_First_Name"] = this.state.card_info['Credit_Card_Holder_First_Name']
            this.state.formData["Credit_Card_Holder_Last_Name"] = this.state.card_info['Credit_Card_Holder_Last_Name']
            this.state.formData["Month_of_Expiry"] = this.state.card_info['Month_of_Expiry']
            this.state.formData["Year_of_Expiry"] = this.state.card_info['Year_of_Expiry']
            this.state.formData['CreditCardProcessingFee'] = 0.03 * ( this.state.amount + this.state.shipping);


        }

        if(e.target.id == "shipment"){
            this.state.formData['CreditCard'] = false; 
            this.setState({CreditCard:e.target.value})
            this.state.formData['PaymentMethod'] = 'Check';
            this.state.formData['CreditCardProcessingFee'] = 0 * this.state.amount;


            // console.log('CreditCard =>', this.state.CreditCard)
        }

        if(e.target.id == "ACH_payment"){
            this.state.formData['CreditCard'] = false; 
            this.setState({CreditCard:e.target.value})
            // this.state.formData['PaymentMethod'] = 'ACH Payment';
            this.state.formData['PaymentMethod'] = 'ACH Payment';
            this.state.formData["Credit_Card_Number"] = ""
            this.state.formData["CVV"] = ""
            this.state.formData['Credit_Card_Holder_First_Name'] = ""
            this.state.formData['Credit_Card_Holder_Last_Name'] = ""
            this.state.formData['Month_of_Expiry'] = ""
            this.state.formData['Year_of_Expiry'] = ""
            this.state.formData['CreditCardProcessingFee'] = 0 * this.state.formData['amount'];
      


            // console.log('CreditCard =>', this.state.CreditCard)
        }

        this.setState({Payment_Type:e.target.value})
        this.state.formData['Payment_Type'] = e.target.value; 
        this.checkProcessingfee();

    }


    verifyAddressWithFedex = (e) => {
        let fields = this.state.formData;
        let errors = {};
        let formIsValid = true;
        // let scroll = {};
        const yOffset = -30;
        const new_yOffset = -60;
        

        if(!fields["Country"]){
            formIsValid = false;
            errors["Country"] = "Please enter Country";
            let element = document.getElementById("Country");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }        
       
        if(!fields["State"]){
            formIsValid = false;
            errors["State"] = "Please enter State";
            let element = document.getElementById("State");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }
        if(!fields["ZipCode"]){
            formIsValid = false;
            errors["ZipCode"] = "Please enter Zip Code";
            let element = document.getElementById("ZipCode");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["Phone"]){
            formIsValid = false;
            errors["Phone"] = "Please enter Phone";
            let element = document.getElementById("Phone");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(isNaN(fields["Phone"]) && fields["Phone"]){
            formIsValid = false;          
            errors["Phone"] = "Please insert number only";
            let element = document.getElementById("Phone");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
         }

        if(!fields["City"]){
            formIsValid = false;
            errors["City"] = "Please enter City";
            let element = document.getElementById("City");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["Street"]){
            formIsValid = false;
            errors["Street"] = "Please enter Street";
            let element = document.getElementById("Street");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        this.setState({errors: errors});

        if(formIsValid){
            this.setState({loading:true})
            
           this.state.City = fields["City"];
           this.state.Street = fields["Street"];
           this.state.State = fields["State"];
           this.state.ZipCode = fields["ZipCode"];
           this.state.Country = fields["Country"];
           this.state.formData['AddressFedExVerified'] = true;

            this.setState({'ShippingLabel':true});
            const newList = {'Country':fields["Country"],'Street':fields["Street"],'City':fields["City"],'State':fields["State"],'ZipCode':fields["ZipCode"],'Phone':fields["Phone"]}
            // const newList = this.state.formData;
            this.props.verifyAddressWithFedex(newList,this.props.history);
            this.setState({isOpen:true});

        }


    }

    acceptShiping = (e) =>{

        this.setState({resetAddress:true});   
        this.state.formData['Street'] = this.state.newAddress.streetLinesToken[0]
        this.state.formData['City'] = this.state.newAddress.city
        this.state.formData['State'] = this.state.newAddress.stateOrProvinceCode
        this.state.formData['Country'] = this.state.newAddress.countryCode
        var zip = this.state.newAddress.postalCode.split("-");
        this.state.formData['ZipCode'] = zip[0]

        this.setState({isOpen:false});
        

        this.getFedexShipQuote();
    }

    rejectShiping = (e) =>{
        this.setState({resetAddress:true});        
        this.state.formData['Street'] = this.state.Street
        this.state.formData['City'] = this.state.City
        this.state.formData['State'] = this.state.State
        this.state.formData['ZipCode'] = this.state.ZipCode
        this.getFedexShipQuote();
        this.setState({isOpen:false});

        
    }

    getFedexShipQuote = (e) => {
            // alert(e);
            // console.log('vale ------ ',e);
            let fields = this.state.formData;
        let errors = {};
        let formIsValid = true;
        // let scroll = {};
        const yOffset = -30;
        const new_yOffset = -60;
        

        if(!fields["Country"]){
            formIsValid = false;
            errors["Country"] = "Please enter Country";
            let element = document.getElementById("Country");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }        
       
        if(!fields["State"]){
            formIsValid = false;
            errors["State"] = "Please enter State";
            let element = document.getElementById("State");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }
        if(!fields["ZipCode"]){
            formIsValid = false;
            errors["ZipCode"] = "Please enter Zip Code";
            let element = document.getElementById("ZipCode");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["Phone"]){
            formIsValid = false;
            errors["Phone"] = "Please enter Phone";
            let element = document.getElementById("Phone");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(isNaN(fields["Phone"]) && fields["Phone"]){
            formIsValid = false;          
            errors["Phone"] = "Please insert number only";
            let element = document.getElementById("Phone");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
         }

        if(!fields["City"]){
            formIsValid = false;
            errors["City"] = "Please enter City";
            let element = document.getElementById("City");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["Street"]){
            formIsValid = false;
            errors["Street"] = "Please enter Street";
            let element = document.getElementById("Street");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }
        if(!fields["ShipmentDate"]){
            formIsValid = false;
            errors["ShipmentDate"] = "Please enter Shipment Date";
            let element = document.getElementById("ShipmentDate");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        } 

        if(!fields["ShippingLabelType"]){
            formIsValid = false;
            errors["ShippingLabelType"] = "Please Choose Courier Service";
            let element = document.getElementById("ShippingLabelType");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        } 
        if(!fields["pickupCompanyName"]){
            formIsValid = false;
            errors["pickupCompanyName"] = "Please enter Company Name";
            let element = document.getElementById("pickupCompanyName");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        this.setState({errors: errors});

        if(formIsValid){
            this.setState({loading:true})
            // this.setState({isOpen:false});
            let fields = this.state.formData;
            this.setState({'ShippingLabel':true});
            // const newList = {'Country':fields["Country"],'Street':fields["Street"],'City':fields["City"],'State':fields["State"],'ZipCode':fields["ZipCode"],'Phone':fields["Phone"],'CompanyName': fields["pickupCompanyName"]}
            const newList = {'Country':fields["Country"],'Name': fields["FirstName"],'CompanyName': fields["pickupCompanyName"],'Street':fields["Street"],'City':fields["City"],'State':fields["State"],'ZipCode':fields["ZipCode"],'Phone':fields["Phone"],'ShipmentDate':fields["ShipmentDate"]}
           
            // const newList = this.state.formData;
            // this.props.getFedexShipQuote(newList,this.props.history);
            if(this.state.formData['ShippingLabelType'] == 'UPS'){
                
                this.props.getShippingUPSLabel(newList,this.props.history);

            }else{
                this.props.getShippingLabel(newList,this.props.history);

            }
        }


        
    }

    verifyClient = (e) => {
        e.preventDefault();    
        // window.scrollTo(0, 500);
          
        let fields = this.state.formData;
        let errors = {};
        let formIsValid = true;
        // let scroll = {};
        const yOffset = -30;
        
      
        if(!fields["Client_id"]){
            formIsValid = false;
            errors["Client_id"] = "Please enter Client Id";
            let element = document.getElementById("Client_id");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            this.setState({isChecked: false});
            element.className = "form-control error"
        }
        if(!fields["Client_lastname"]){
            formIsValid = false;
            errors["Client_lastname"] = "Please enter client last name";
            let element = document.getElementById("Client_lastname");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
            this.setState({isChecked: false});
        }
      

      this.setState({errors: errors});

      // console.log('check value => ',this.state.isChecked)
      if(formIsValid){
          // this.setState({ loading: true });  
        this.setState({verify_client: true});         
        var newList = {ClientId:fields["Client_id"],ClientLastname:fields["Client_lastname"]}
        // console.log("newlist=>", newList);
        this.props.verifyClientData(newList, this.props.history);
        this.setState({loading:true})
          
      }
    
    
    
    
    }
    

    onSubmit = (e) => {              
        e.preventDefault();    
        // window.scrollTo(0, 500);
          
        let fields = this.state.formData;
        let errors = {};
        let formIsValid = true;
        // let scroll = {};
        const yOffset = -80;
        // console.log('verify_client ',this.state.verify_client)

       
        if(!fields["ShippingLabelType"]){
            formIsValid = false;
            errors["ShippingLabelType"] = "Please Choose Courier Service";
            let element = document.getElementById("ShippingLabelType");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        } 
       

        if(!fields["Country"]){
            formIsValid = false;
            errors["Country"] = "Please enter Country";
            let element = document.getElementById("Country");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }        
       
        if(!fields["State"]){
            formIsValid = false;
            errors["State"] = "Please enter State";
            let element = document.getElementById("State");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }
        if(!fields["ZipCode"]){
            formIsValid = false;
            errors["ZipCode"] = "Please enter Zip Code";
            let element = document.getElementById("ZipCode");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["Phone"]){
            formIsValid = false;
            errors["Phone"] = "Please enter Phone";
            let element = document.getElementById("Phone");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(isNaN(fields["Phone"]) && fields["Phone"]){
            formIsValid = false;          
            errors["Phone"] = "Please insert number only";
            let element = document.getElementById("Phone");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
         }

        if(!fields["City"]){
            formIsValid = false;
            errors["City"] = "Please enter City";
            let element = document.getElementById("City");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["Street"]){
            formIsValid = false;
            errors["Street"] = "Please enter Street";
            let element = document.getElementById("Street");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }
       
        if(!fields["ShippingEmail"]){
            formIsValid = false;
            errors["ShippingEmail"] = "Please enter Shipping Email";
            let element = document.getElementById("ShippingEmail");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if (fields["ShippingEmail"] != "" && !validator.isEmail(fields["ShippingEmail"])) {
            formIsValid = false;
            errors["ShippingEmail"] = "Please enter valid Shipping Email";
            let element = document.getElementById("ShippingEmail");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
          }

        

        if(!fields["FirstName"]){
            formIsValid = false;
            errors["FirstName"] = "Please enter first name";
            let element = document.getElementById("FirstName");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["LastName"]){
            formIsValid = false;
            errors["LastName"] = "Please enter last name";
            let element = document.getElementById("LastName");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

         

        if(this.state.shipping_value=="yes"){

            if(this.state.formData['FirstName'] == null || this.state.formData['Street'] == null || this.state.formData['City'] == null || this.state.formData['State'] == null  || this.state.formData['Country'] == null ){
                formIsValid = false;
                errors["use_new_shipping_address"] = "Please select shipping address";
                let element = document.getElementById("use_new_shipping_address");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
            }

        }


        
      


   

    

    if(!fields["ShipmentDate"]){
        formIsValid = false;
        errors["ShipmentDate"] = "Please enter Shipment Date";
        let element = document.getElementById("ShipmentDate");                
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
        element.className = "form-control error"
    } 

    if(fields["ShipmentDate"]){
        var newHolidayDate = this.subtractOneDay(fields['ShipmentDate']);
        var selected_day = Moment(fields["ShipmentDate"]).day();
        if(this.state.formData['shipping_method']=="FedEx"){
            // console.log('selected day before =>', selected_day );
            if(selected_day == 1 || selected_day == 0){
                // console.log('selected day =>', Moment(e).day() );
                
                errors["ShipmentDate"] = "FedEx does not deliver on Sunday and Monday. Please choose a different date from Tuesday to Saturday for shipment arrival";
                let element = document.getElementById("ShipmentDate");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
                
                formIsValid = false;
              
            }
            else if(this.state.holidayDates.includes(fields["ShipmentDate"]) ){
                // console.log('selected day =>', Moment(e).day() );
                
                errors["ShipmentDate"] = "FedEx does not deliver on Holidays. Please choose a different date from holiday for shipment arrival.";
                let element = document.getElementById("ShipmentDate");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
                formIsValid = false;
              //  this.state.formData['ShipmentDate'] = "";
              
            }
            else if(this.state.holidayDates.includes(newHolidayDate) ){
                // console.log('selected day =>', Moment(e).day() );
                
                errors["ShipmentDate"] = "FedEx does not deliver on Holidays or day after. Please choose a different date from holiday for shipment arrival";
                let element = document.getElementById("ShipmentDate");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
                formIsValid = false;
               // this.state.formData['ShipmentDate'] = "";
              
            }
        }else if(this.state.formData['shipping_method'] =='ACT VIP'){
            errors["ShipmentDate"] = "";
            formIsValid = true;

        }

    }

    if(fields["ShipmentDate"]){
        const dateFormat = 'MM-DD-YYYY';
        const yr = new Date(fields["ShipmentDate"]).getFullYear();
        const toDateFormat = Moment(new Date(fields["ShipmentDate"])).format(dateFormat);
        let validDate = Moment(toDateFormat, dateFormat, true).isValid();
        if(!validDate || yr >= 2050){
            formIsValid = false;
            errors["ShipmentDate"] = "Invalid date ";
            let element = document.getElementById("ShipmentDate");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }
    }

    if( fields["Payment_Type"] == "" ){
        formIsValid = false;
        errors["CreditCard"] = "Please Select Payment Method";
        let element = document.getElementById("credit_card");                
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
        // element.className = "form-control error"
    } 

    if(this.state.formData['Payment_Type'] == "ACH" ) {
        if(!fields["Account_Number"] ){
            formIsValid = false;
            errors["CreditCard"] = "Please store your ACH Details in the update payment information tab to use ACH Payment Method.";
            let element = document.getElementById("ACH_payment");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }

        if(!fields["Account_Number"] ){
            formIsValid = false;
            errors["Account_Number"] = "Please enter account number";
            let element = document.getElementById("Account_Number");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }
        if(!fields["Name_On_Account"] ){
            formIsValid = false;
            errors["Name_On_Account"] = "Field cann't be empty";
            let element = document.getElementById("Name_On_Account");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

        if(!fields["ABA_Routing_Number"] ){
            formIsValid = false;
            errors["ABA_Routing_Number"] = "Field cann't be empty";
            let element = document.getElementById("ABA_Routing_Number");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            element.className = "form-control error"
        }

    }
        

        if(this.state.update_card == true || this.state.Payment_Type == "CC"){

            if(!fields["Credit_Card_Number"]){
                formIsValid = false;
                errors["Credit_Card_Number"] = "Please enter credit card number";
                let element = document.getElementById("Credit_Card_Number");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
            }
            if(fields["Credit_Card_Number"]) {
                let cardvalid = valid.number(fields["Credit_Card_Number"]);
                // console.log('cardvalid',cardvalid);
                if(!cardvalid.isValid){
                    formIsValid = false;
                    errors["Credit_Card_Number"] = "Invalid credit card number.";
                    let element = document.getElementById("Credit_Card_Number");                
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
                }
            }

            if(!fields["CVV"]){
                formIsValid = false;
                errors["CVV"] = "Please enter CVV";
                let element = document.getElementById("CVV");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
                element.className = "form-control error"
            }

            if(fields["CVV"] && !/^\d{3,4}$/.test(fields["CVV"])) {
                formIsValid = false;
                errors["CVV"] = "Invalid CVV code"; 
                let element = document.getElementById("CVV");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});   
                element.className = "form-control error"            
            }

            

            if(!fields["Month_of_Expiry"]){
                formIsValid = false;
                errors["Month_of_Expiry"] = "Cannot be empty";
                let element = document.getElementById("Month_of_Expiry");                
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({top: y, behavior: 'smooth'});
                    element.className = "form-control error"
            } 
    
       

            if(!fields["Year_of_Expiry"]){
                formIsValid = false;
                errors["Year_of_Expiry"] = "Cannot be empty";
                let element = document.getElementById("Year_of_Expiry");                
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({top: y, behavior: 'smooth'});
                    element.className = "form-control error"
                } 
    
                

        }

        if(!this.state.ShippingLabel && this.state.showFeedex) {
            formIsValid = false;
                errors["ShippingLabel"] = "Please verify shipping address.";
                let element = document.getElementById("shipBtn");                
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
        }

        if(this.state.verify_client === false && this.state.showFeedex){
            formIsValid = false;
            errors["verify_client"] = "Please confirm client details";
            let element = document.getElementById("verify_client");                
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
            // this.setState({isChecked: false});
            // element.className = "form-control error"
          }


        // console.log('formIsValid --- ', formIsValid)
        this.setState({errors: errors});

        // console.log('amount => ', this.state.formData['amount'])
        

        if(formIsValid){
            // this.setState({ loading: true });  
            this.state.formData['amount'] = this.state.amount+this.state.formData['CreditCardProcessingFee']+this.state.shipping;
            this.state.formData['amount'] = this.state.formData['amount'].toFixed(3)
           
            const newList = this.state.formData;
            // console.log("newlist=>", newList);
            this.props.setStoreRequest(newList, this.props.history);
            this.setState({loading:true})
        }



    }

    closeModal = (e) => {
        this.state.isOpen = false;
        this.setState({isOpen:false});
        // alert('close');

    }



    render() {
        const {formData} = this.state
        if(!sessionStorage.getItem('physician_id') || sessionStorage.getItem('physician_id')==null) {           
            return <Redirect to="../" />
          } 
        return (
            <MainLayout>
                <Header />
                    <Modal
                    isOpen={this.state.isOpen}
                    onAfterOpen={this.afterOpenModal}
                    style={this.state.customStyles}
                    contentLabel="Example Modal"
                    >
                    <h2 className="title-3">FedEx Suggested Address</h2>
                    <hr></hr>
                    <div> 
                    {(this.state.newAddress.city)?
                    <div>
                    <p><b>Street</b>:{this.state.newAddress.streetLinesToken[0]}</p>
                    <p><b>City</b>:{this.state.newAddress.city}</p>
                    <p><b>State</b>:{this.state.newAddress.stateOrProvinceCode}</p>
                    <p><b>Country</b>:{this.state.newAddress.countryCode}</p>
                    <p><b>ZipCode</b>:{this.state.newAddress.postalCode}</p>

                    </div>
                    :""}


                    </div>
                    <div class="">
                    <button id="1" type="button" class="btn btn-outline-primary mr-2" onClick={this.rejectShiping}>Bypass Suggestion</button>
                    <button type="button" class="btn btn-primary" onClick={this.acceptShiping}>Accept Suggestion</button>
                    </div>
                    </Modal>
                <div className="main-content">
                    <Left activeMenu={"purchase-label"}/> 
                    { (this.state.loading)?
                    <div class="loading-div">
                        <div class="loading-img"><img src="../images/spinner.svg" alt="" /></div>
                    </div>:""}

                    <div className="right-section">
                        <div className="pagesubheader-wrap">
                        <div className="pagesubheader-row">
                            <div className="page-subheader-col-left">
                            <div className="title-avatar">
                                <img src="images/physician-icon.svg" alt="" />
                            </div>
                            <div className="title-main">
                                <span className="title-sub-text">Physician Portal</span>
                                <h1>ACT Store</h1>
                            </div>
                            </div>
                        </div>
                        </div>

                        {(this.state.payment_response)?
                        <div>
                            <h5 style={{padding:"10px"}}><i>Please check your email for order confirmation </i></h5>
                        </div>:  
                        <div className="inner-content-area">                      
                        <form className="needs-validation" noValidate onSubmit={this.onSubmit}>
                        
                        <div className="summary-section-wrap">                         
                        <div className="left-section-content">  
                        <span style={{color: "red"}}>{this.state.api_error}</span>
                       
                        <div className="form-wrap">
                         
                            <div className="mid-sections">
                            {/* <h2 className="title-2 mb-4">ACT Store </h2> */}

                            {/* <h6 class="title-3 mb-4">Please Select Items:</h6>
                            <div className="quantity">
                            <h6>Initial Processing Banking Kits</h6>
                            <ul>
                                <li>
                                Banking kits provided to the clinic for initial sample harvesting. These kits include icepacks to be put in the freezer and conical tubes for sample collection. Conical tubes should be placed in refrigerator upon receiving kit. Expiration dates are directly printed on conical tubes. 
                                </li>
                            </ul>
                            <div  >Initial processing banking kits ($0 charge)</div>
                            <input type="button" value="-" name="ip" class="btn minus btn-secondary"  onClick={this.remove_quantity} />
                            <input type="text" id="ip_quantity" name="ip" value={this.state.formData["ip"]["quantity"]} class="qty" onBlur={this.check_quantity} />
                            <input type="button" value="+" name="ip" class="btn plus btn-primary"  onClick={this.add_quantity} />
                            <h3 class="title-2"></h3>
                            </div>

                            <div className="quantity">
                            <h6>Bloodwork Kits</h6>
                            <ul>
                            <li>Bloodwork Kits are for Clients using ACT White Glove Labs for recommended infectious disease screening bloodwork. These kits include blood draw instructions, SST tubes for blood collection, and pre-paid shipping labels</li>
                                <li>For blood draw instructions please see here:  <a target="__blank" href="images/BloodDrawInstructions1.jpg">American Cell Technology Blood Collection Instructions. </a></li>
                                
                            </ul>
                            <div >Bloodwork kits ($0 charge)</div>
                            <input type="button" value="-" name="bloodwork" class="btn minus btn-secondary"  onClick={this.remove_quantity} />
                            <input type="text" id="bloodwork" name="bloodwork" value={this.state.formData["bloodwork"]["quantity"]} class="qty" onBlur={this.check_quantity} />
                            <input type="button" value="+" name="bloodwork" class="btn plus btn-primary"  onClick={this.add_quantity} />
                            <h3 class="title-2"></h3>
                            </div>

                            <div className="quantity">
                            <h6>Mini-Lipo One-Time Use Kits</h6>
                            <ul>
                            <li>Mini-Lipo One Time Use Kits include the following: 
                                <ul>
                                    <li>Single use infiltrator</li>
                                    <li>Single use speed harvester</li>
                                    <li>Single use Johnnie Snap 50cc (designed to maintain vacuum at variable pressure levels, from low to high)</li>
                                    <li>50cc syringe</li>
                                    <li>50cc syringe</li>
                                </ul>
                            </li>
                                <li>For mini-lipo harvesting guidance instructions please see here: <a target="__blank" href="images/Procedure for Harvesting and Sending Fat to ACT.pdf">Procedure Guidance for Adipose Harvesting</a> </li>
                            </ul>
                            <div >Mini-lipo one-time use kits ($250 per kit, $200 if ordering 5 or more)</div>
                            <input type="button" value="-" name="mini-lipo"  class="btn minus btn-secondary"  onClick={this.remove_quantity} />
                            <input type="text" id="mini-lipo" name="mini-lipo" value={this.state.formData["minilipo"]["quantity"]} class="qty" onBlur={this.check_quantity} />
                            <a class="btn plus btn-primary" name="mini-lipo"  onClick={this.add_mini_quantity} > + </a>
                            </div>
                            <span style={{color: "red"}}>{this.state.errors["Services"]}</span>   
                           
                            <h3 class="title-2"></h3>

                             */}

                            <div className="quantity row">
                            <div className="col-md-12"> 

                            <h6>New Sample Overnight Shipping Label</h6>
                            <select className="custom-select d-block col-md-6" id="ShippingLabelType" onChange={this.onChange}  placeholder="Shipping Label"  >
                            <option value="">Please Choose Courier Service</option>
                            <option value="FedEx">FedEx</option>
                            {/* <option value="UPS">UPS</option> */}
                            <span style={{color: "red"}}>{this.state.errors["ShippingLabelType"]}</span>   

                            </select>
                        <br></br>
                            <p>This shipping label is for initial samples only being shipped to ACT via overnight service (<b>FedEx Priority Overnight or UPS Next Day Air</b>).</p>
                            <p>Click Confirm Ship From Address to view the current shipping rate based on your selected courier and ship-from address.</p>
                            
                       
                            <input type="button" value="-" name="shippingLabel"  class="btn minus btn-secondary"  onClick={this.remove_quantity} />
                            <input type="text" id="shippingLabel" name="shippingLabel" value={this.state.formData["shippingLabel"]["quantity"]} class="qty" onBlur={this.check_quantity} />
                            <a class="btn plus btn-primary" name="shippingLabel"  onClick={this.add_quantity} > + </a>
                            <br/> 

                            </div>
                            
                            <span style={{color: "red"}}>{this.state.errors["Services"]}</span> 

                            </div>
                            <br/>
                            {(this.state.showFeedex)?
                                
                                <div className="mid-sections">
                           <p><b>Please Enter Client ID and Last Name</b></p> 
                            
                                <div className="row">

                         <div className=" col-md-6">
                        <div className="form-group">
                        <label  className="col-form-label">Client ID </label>
                        <div className="field-col">
                            <input type="text" id="Client_id" value={this.state.formData['Client_id']} className="form-control"  onChange={this.onChange} placeholder=""  />
                            <span style={{color: "red"}}>{this.state.errors["Client_id"]}</span>
                        </div>
                        </div>
                        </div>
                        <div className=" col-md-6">
                        <div className="form-group">
                        <label  className="col-form-label">Client Last Name</label>
                        <div className="field-col">
                            <input type="text" className="form-control" value={this.state.formData['Client_lastname']} id="Client_lastname" readOnly={this.state.disableField} onChange={this.onChange} placeholder=""  />
                            <span style={{color: "red"}}>{this.state.errors["Client_lastname"]}</span>
                        </div>
                        </div>
                        </div>

                        <div className=" col-md-12">
                                <button type="button" style={{marginLeft:'10%'}}  className="btn btn-secondary" id="verify_client" onClick={this.verifyClient}>Confirm Client Details</button>
                                <br /><span style={{color: "red"}}>{this.state.errors["verify_client"]}</span>
                                <span style={{color: "green",margin:"1%"}}> {this.state.client_success_msg}</span>
                                    
                        </div></div>
                                </div>:""}
                                <i><span className="required">*</span>Shipping labels must be used within 7 days of purchase. Expired labels are non-refundable. By purchasing, you agree to this policy.</i>
                        <br/>
                        <i><span className="required">*</span>If you are purchasing a shipping label in this order, please select a ship date within 7 days of the purchase date.</i>
                        <br/>

                            {/* <h3 class="title-2"></h3> */}
                            <br/>

                           
                                
                            {/* <h2 className="title-2 mb-4">Shipping Method</h2>
                            <div className="row">
                                <div className="col-md-5">
                                <div className="form-group">
                                    <label>Courier Service</label>
                                    <select className="form-control" disabled id="shipping_method" onChange={this.onChange}>
                                    <option value="FedEx">FedEx</option>
                                    <option value="FedEx">UPS</option>
                                    </select>
                                </div>
                                </div>                                
                            </div> */}

                            </div>
                      
                            <div className="mid-sections">
                            <h2 className="title-2 mb-4">Shipping Date</h2>
                            {/* <p>If you have Bio-Insurance or Longevity Cells available, you may order your cells to be shipped on the next available business day if using FedEx Priority or shipped within 24 hours if using the ACT VIP Courier Service
                            </p> */}
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                <label className="col-form-label">Ship Date (mm/dd/yyyy) <span className="required">*</span></label>
                                <div className="field-col">
                                <DatePicker id="ShipmentDate" className="form-control bggray" minDate={this.state.myFutureDate}  placeholderText="mm/dd/yyyy" selected={this.state.ShipmentDate}  onChange={date => this.datechange1(date)} /> <br />
                                    {/* <input type="text" className="form-control" placeholder="#04/04/2021" /> */}
                                    <span style={{color: "red"}}>{this.state.errors["ShipmentDate"]}</span>
                                </div>
                                
                                </div>
                            </div>
                            <div className="mid-sections">
                             <h2 className="title-2 mb-4">Address Information</h2>
                             <p>If you are purchasing a shipping label purchase,the following address will be your pickup address</p>
                            {/*<div className="saved-address-wrap">
                                <h3 className="title-3">Select saved shipping address</h3>
                                <div className="saved-address custom-control custom-radio" style={{zIndex:"0"}}>
                                <input type="radio" className="custom-control-input" name="shipping_value" id="use_save_shipping_address" value="yes" onChange={this.UseShipping} />
                                <label className="custom-control-label" htmlFor="use_save_shipping_address">
                                    <strong>{this.state.shippindetails['FirstName']} {this.state.shippindetails['LastName']}</strong><br />
                                    <span> {this.state.shippindetails['Street']}, {this.state.shippindetails['City']}, {this.state.shippindetails['State']} <br />
                                    {this.state.shippindetails['Country']} {this.state.shippindetails['ZipCode']} {this.state.shippindetails['Phone']} </span>
                                </label>
                                </div>
                            </div>
                            <div className="saved-address-wrap">                            
                                <div className="saved-address custom-control custom-radio">
                                <input type="radio" className="custom-control-input" name="shipping_value" id="use_new_shipping_address" value="no" onChange={this.UseShipping} />
                                <label className="custom-control-label" htmlFor="use_new_shipping_address"> <b>Select new shipping address</b></label>
                               
                                <br />
                                <span style={{color: "red"}}>{this.state.errors["use_new_shipping_address"]}</span>
                                </div>
                            </div> */}
                        
                            <div className="new-address-wrap">
                                {/* <h3 className="title-3 mb-5"> shipping address</h3> */}
                                <div className="form-wrap">
                                <div className="row">
                                <div className="col-md-6">
                                <div className="form-group">
                                <label className="col-form-label">Company Name <span className="required">*</span></label>
                                <div className="field-col">
                                <input type="email" className="form-control" id="pickupCompanyName" value={this.state.formData['pickupCompanyName']} placeholder="" maxLength={35} onChange={this.onChange}  />
                                <span style={{color: "red"}}>{this.state.errors["pickupCompanyName"]}</span>
                                </div>

                                </div>
                                </div>

                                <div className="col-md-6">
                                            <div className="form-group">
                                            <label className="col-form-label">First Name <span className="required">*</span></label>
                                            <div className="field-col">
                                                <input type="text" className="form-control" id="FirstName" value={this.state.formData['FirstName']} placeholder="" onChange={this.onChange} />
                                                <span style={{color: "red"}}>{this.state.errors["FirstName"]}</span>
                                            </div>
                                            
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label className="col-form-label">Last Name <span className="required">*</span></label>
                                            <div className="field-col">
                                                <input type="text" className="form-control" id="LastName" value={this.state.formData['LastName']} placeholder="" onChange={this.onChange} />
                                                <span style={{color: "red"}}>{this.state.errors["LastName"]}</span>
                                            </div>
                                            
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label className="col-form-label">Shipping Email <span className="required">*</span></label>
                                            <div className="field-col">
                                                <input type="email" className="form-control" id="ShippingEmail" value={this.state.formData['ShippingEmail']} placeholder="" onChange={this.onChange}  />
                                                <span style={{color: "red"}}>{this.state.errors["ShippingEmail"]}</span>
                                            </div>
                                            
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label className="col-form-label">Shipping Phone <span className="required">*(Numbers only)</span></label>
                                            <div className="field-col">
                                                <input type="text" className="form-control" id="Phone" value={this.state.formData['Phone']} placeholder="" onChange={this.onChange}  />
                                                <span style={{color: "red"}}>{this.state.errors["Phone"]}</span>
                                            </div>
                                            
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="col-form-label">Street <span className="required">*</span></label>
                                                <div className="field-col">
                                                <input type="text" className="form-control" id="Street" value={this.state.formData['Street']} placeholder="" onChange={this.onChange} />
                                                <span style={{color: "red"}}>{this.state.errors["Street"]}</span>
                                                </div>
                                                
                                            </div>
                                            </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label className="col-form-label">City <span className="required">*</span></label>
                                            <div className="field-col">
                                                <input type="text" className="form-control" id="City" value={this.state.formData['City']} placeholder="" onChange={this.onChange} />
                                                <span style={{color: "red"}}>{this.state.errors["City"]}</span>
                                            </div>
                                            
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="col-form-label">State <span style={{color:"#0070D2"}}>(two letter State Abbreviation only)*</span></label>
                                                <div className="field-col">
                                                <input type="text" className="form-control" id="State" value={this.state.formData['State']} placeholder="" onChange={this.onChange} />
                                                <span style={{color: "red"}}>{this.state.errors["State"]}</span>
                                                </div>
                                                
                                            </div>
                                            </div>
                                        

                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label className="col-form-label">Zip Code <span className="required">*</span></label>
                                            <div className="field-col">
                                                <input type="text" className="form-control" id="ZipCode" value={this.state.formData['ZipCode']} placeholder="" onChange={this.onChange} />
                                                <span style={{color: "red"}}>{this.state.errors["ZipCode"]}</span>
                                            </div>
                                            
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label className="col-form-label">Country <span className="required">*</span></label>
                                            <div className="field-col">
                                            <input type="text" className="form-control" id="Country" value={this.state.formData['Country']} placeholder="" onChange={this.onChange} />
                                            <span style={{color: "red"}}>{this.state.errors["Country"]}</span>
                                            </div>
                                            
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                        <div className="form-group save-address-checkbox">
                                            <div className="custom-control custom-checkbox">
                                            <input type="checkbox" className="custom-control-input" id="saveAddressForFuture" onChange={this.onChange}  />
                                            <label className="custom-control-label" htmlFor="saveAddressForFuture">Saved Addresses For Future</label>
                                            </div>
                                        </div>
                                        </div>

                                        <div className="col-md-12">
                                        {(this.state.showFeedex)?
                                        <button type="button" id="shipBtn" onClick={this.getFedexShipQuote} className="btn btn-primary">Confirm Ship From Address</button>
                                        :""}
                                        <span className="col-md-6" style={{color: "red"}}>{this.state.errors["ShippingLabel"]}</span>
                                        <span style={{color: "green",margin:"1%"}}> {this.state.success_fedexmsg}</span>
                                        </div>
                                    
                                </div>
                                </div>
                            </div>

                            </div>

                            <h3 class="title-2"></h3>
                            

                        <div className="row" >
                            <div class="submission-detail-sec col-md-12">

                            <h3 class="title-3 mb-4">Please Choose a Payment Method :</h3>
                            <i>*Important Payment Information:
                            A 3% credit card processing fee will be added to all transactions paid via credit card. To avoid this fee, you may choose to pay via ACH. Thank you for trusting us to safely store your personal stem cells!</i>
                            <p></p>
                            <div class="choose-options-sec">
                            <div class="custom-control custom-radio">
                            <input type="radio" id="credit_card" name="CreditCard" checked={this.state.Payment_Type === "CC"} class="custom-control-input" value="CC" onClick={this.checkPayment} />
                            <label class="custom-control-label" for="credit_card">Credit Card</label>
                            </div>
                            {/* <div class="custom-control custom-radio">
                            <input type="radio" id="shipment" name="CreditCard" class="custom-control-input" value="Check" onClick={this.checkPayment}/>
                            <label class="custom-control-label" for="shipment">Check </label>
                            </div>   */}
                            <div class="custom-control custom-radio">
                            <input type="radio" id="ACH_payment" checked={this.state.Payment_Type === "ACH"} name="CreditCard" class="custom-control-input" value="ACH" onClick={this.checkPayment}/>
                            <label class="custom-control-label" for="ACH_payment">ACH Payment</label>
                            </div>                                        
                            </div>
                            <span style={{color: "red"}}>{this.state.errors["CreditCard"]}</span>
                            <br />
                          
                            {(this.state.Payment_Type == "CC")? 

                            
                                    <div className=" payment-info card" style={{width:'100%'}}>
                                        <div className="card-header">
                                        <h4>Current Payment Method Secured For Services </h4>
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" className="custom-control-input" id="customCheck2" defaultChecked />
                                            <label className="custom-control-label" htmlFor="customCheck2" />
                                        </div>
                                        </div>
                                        <div className="card-body">
                                            {(this.state.card_last_gid !='')?
                                        <div className="saved-card-detail">
                                            <div className="row">
                                            <div className="col-md-6">
                                                <label>Card Number</label>
                                                <div className="card-dtl-value">
                                                <img className="card-logo" src="images/master-card.png" alt="" />
                                                <span>Credit Card ending in {this.state.card_last_gid}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <label>Name on card</label>
                                                <div className="card-dtl-value">
                                                <span>{this.state.card_info['Credit_Card_Holder_First_Name']} {this.state.card_info['Credit_Card_Holder_Last_Name']}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <label>Expiry</label>
                                                <div className="card-dtl-value">
                                                <span>{this.state.card_info['Month_of_Expiry']} / {this.state.card_info['Year_of_Expiry']}</span>
                                                </div>
                                            </div>
                                            </div>
                                        <br />
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" id="update_card" name="update_card" className="custom-control-input" value="true" onClick={this.checkRadio3}/>
                                            <label className="custom-control-label" for="update_card">Use Another Credit Card </label>
                                          
                                        </div></div>:""}

                                        {(this.state.update_card == true || this.state.card_last_gid == '')?
                                        <div className="card-edit">
                                            <div className="card-detail-form">
                                            <div className="card-detail-wrap mb-5">
                                                <h5>Credit Card Detail <img src="images/info.svg" data-toggle="tooltip" data-placement="top" title alt="" data-original-title="Tooltip Text" /></h5>
                                                <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                    <label>Credit Card Number <span className="required">*</span> </label>
                                                    <input type="text" id="Credit_Card_Number" className="form-control" placeholder="Card number" onChange={this.onChange} />
                                                    <span style={{color: "red"}}>{this.state.errors["Credit_Card_Number"]}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                    <label>CVV <span className="required">*</span> </label>
                                                    <input type="password" id="CVV" className="form-control" placeholder="***" onChange={this.onChange} />
                                                    <span style={{color: "red"}}>{this.state.errors["CVV"]}</span>
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-3">
                                                    <div className="form-group">
                                                    <label>Expiry Date <span className="required">*</span> </label>
                                                    <input type="text" className="form-control" placeholder="-- --  /  -- -- -- --" />
                                                    <span style={{color: "red"}}>{this.state.errors["CreditCard"]}</span>
                                                    </div>
                                                </div> */}

                                            <div className="col-md-6 mb-3">
                                            <label htmlFor="Month_of_Expiry">Expiration Date <span className="act_required">*</span></label>
                                            <select className="custom-select d-block w-100" id="Month_of_Expiry" onChange={this.onChange}  placeholder="mm" >
                                                <option value="">Select Month</option>
                                                <option value="01">01</option>
                                                <option value="02">02</option> 
                                                <option value="03">03</option> 
                                                <option value="04">04</option> 
                                                <option value="05">05</option>    
                                                <option value="06">06</option> 
                                                <option value="07">07</option> 
                                                <option value="08">08</option> 
                                                <option value="09">09</option> 
                                                <option value="10">10</option> 
                                                <option value="11">11</option>
                                                <option value="12">12</option>  
                                            </select>
                                            {/* <input type="text" className="form-control" id="Month_of_Expiry" onChange={this.onChange} placeholder="mm" required /> */}
                                            <span style={{color: "red"}}>{this.state.errors["Month_of_Expiry"]}</span>
                                            <div className="invalid-feedback">
                                            Valid Month required
                                            </div>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                            <label htmlFor="creditCardExpirationYear"> &nbsp;</label>
                                            <select className="custom-select d-block w-100" id="Year_of_Expiry" onChange={this.onChange}  placeholder="YYYY" >
                                            <option value="">Year</option>                                            
                                          
                                            <option value="2025">2025</option>
                                            <option value="2026">2026</option>
                                            <option value="2027">2027</option>
                                            <option value="2028">2028</option>
                                            <option value="2029">2029</option>
                                            <option value="2030">2030</option>
                                            <option value="2031">2031</option>
                                            <option value="2032">2032</option>
                                            </select>
                                            {/* <input type="text" className="form-control" id="creditCardExpirationYear" onChange={this.onChange} placeholder="yy" required /> */}
                                            
                                            <span style={{color: "red"}}>{this.state.errors["Year_of_Expiry"]}</span><div className="invalid-feedback">
                                            Valid Year required
                                            </div>
                                            </div>


                                                
                                                <div className="col-md-12">
                                                    <div className="card-logo-list">
                                                    <div><img src="../images/card-1.svg" alt="" /></div>
                                                    <div><img src="../images/card-2.svg" alt="" /></div>
                                                    <div><img src="../images/card-3.svg" alt="" /></div>
                                                    <div><img src="../images/card-4.svg" alt="" /></div>
                                                    </div>
                                                </div>
                                                </div>
                                                <div>                                            
                                                    <div className="custom-control custom-checkbox">
                                                    <br />
                                                    <input type="checkbox" id="save_card" name="save_card" className="custom-control-input" value="true" onClick={this.savecard}/>
                                                    <label className="custom-control-label" for="save_card">Save this credit card on file for future payments</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-detail-wrap">
                                                <h5>Billing Information <img src="images/info.svg" data-toggle="tooltip" data-placement="top" title alt="" data-original-title="Tooltip Text" /></h5>
                                                <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                    <label>Credit Card Holder's First Name</label>
                                                    <input type="text" id="Credit_Card_Holder_First_Name" className="form-control" placeholder onChange={this.onChange} value={formData.Credit_Card_Holder_First_Name}  />
                                                    <span style={{color: "red"}}>{this.state.errors["Credit_Card_Holder_First_Name"]}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                    <label>Credit Card Holder's Last Name</label>
                                                    <input type="text" id="Credit_Card_Holder_Last_Name" className="form-control" placeholder onChange={this.onChange} value={formData.Credit_Card_Holder_Last_Name}  />
                                                    <span style={{color: "red"}}>{this.state.errors["Credit_Card_Holder_Last_Name"]}</span>
                                                    </div>
                                                </div>
                                                
                                                </div>
                                            </div>
                                            
                                            </div>
                                        </div>
                                        :""}
                                        {/* <div className="act-total">
                                             Total: $ {(this.state.amount)+(this.state.shipping)+(this.state.cpp_price)}
                                        </div> */}

                                        </div>
                                    </div>
  
                            :""}

{(this.state.Payment_Type == "ACH")?    
                             <div className=" payment-info card" style={{width:'100%'}}>

                                <div className="card-header">
                                <h4>ACH Payment Method Secured For Banking </h4>   
                                <div className="custom-control custom-checkbox">
                                            <input type="checkbox" className="custom-control-input" id="customCheck2" defaultChecked />
                                            <label className="custom-control-label" htmlFor="customCheck2" />
                                        </div>                                  
                                </div>  
                                <div className="card-body">
                                {(this.state.card_info['ABA_Routing_Number'] ||  this.state.card_info['Account_Number'])?
                                    <div>
                                        <div className="saved-card-detail">                     
                                        <div class="row">          
                                            {/* <h2 className="title-2">ACH Billing Information</h2> */}
                                            <div class="col-md-4">
                                            <label> Name On Account</label>
                                            <div class="card-dtl-value">
                                            <span>{this.state.card_info['Name_On_Account']}</span>
                                            </div>
                                            </div>             
                                            <div class="col-md-4">
                                            <label>Account Number</label>
                                            <div class="card-dtl-value">
                                            <span>Account Number Ending in {this.state.acc_num}
                                            </span>
                                            </div>
                                            </div>

                                            <div class="col-md-4">
                                            <label>ABA Routing Number</label>
                                            <div class="card-dtl-value"> 
                                            <span>{this.state.card_info['ABA_Routing_Number']}
                                            </span>
                                            </div>
                                            </div>
                                        
                                        
                                        </div>
                                        </div>
                                        <br />

                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" id="update_ach" name="update_ach" className="custom-control-input" value="true" onClick={this.checkAch}/>
                                            <label className="custom-control-label" for="update_ach">Use Another ACH </label>
                                            
                                        </div>
                                        <br />
                                        <div lassName="custom-control">
                                            {(!this.state.card_info['ABA_Routing_Number'] ||  !this.state.card_info['Account_Number'])?
                                            <span><b style={{color: "red"}}>Please store your ACH Details in the <a className="updapte_pay" href="./payment-information">update payment information</a> tab to use ACH Payment Method.</b></span>
                                            
                                            :""}

                                        </div>
                                    
                                            
                                    </div>
                                :""}

                                    

                                    {(!this.state.card_info['ABA_Routing_Number'] ||  !this.state.card_info['Account_Number'] || this.state.update_ach)?

                                        <div className="">   
                                            <div className="card-detail-form">
                                            <div class="row">
                                         <div class="col-md-6">
                                             <div class="form-group">
                                                 <label>Name On Account <span class="required">*</span> </label>
                                                 <input type="text" id="Name_On_Account" class="form-control" placeholder="" onChange={this.onChange} />
                                                 <span style={{color: "red"}}>{this.state.errors["Name_On_Account"]}</span>
                                             </div>
                                         </div>
                                         <div class="col-md-6">
                                             <div class="form-group">
                                                 <label>Account Number<span class="required">*</span> </label>
                                                 <input type="text" id="Account_Number" class="form-control" placeholder="" onChange={this.onChange} />
                                                 <span style={{color: "red"}}>{this.state.errors["Account_Number"]}</span>
                                             </div>
                                         </div>
                                         <div class="col-md-6">
                                             <div class="form-group">
                                                 <label>ABA Routing Number <span class="required">*</span> </label>
                                                 <input type="text" id="ABA_Routing_Number" class="form-control" placeholder="" onChange={this.onChange} />
                                                 <span style={{color: "red"}}>{this.state.errors["ABA_Routing_Number"]}</span>
                                             </div>
                                         </div>

                                         <div className="col-md-12">                                            
                                                <div className="custom-control custom-checkbox">
                                                <br />
                                                <input type="checkbox" id="save_ach" name="save_ach" className="custom-control-input" value="true" onClick={this.saveAch}/>
                                                <label className="custom-control-label" for="save_ach">Save this ACH on file for future payments</label>
                                            
                                                </div>
                                        </div> 

                                        </div>
                                            </div>
                                        </div>
                                    :""}
                                </div>
                            </div>
                                :''} 


                            </div>
                    

                        </div>

                            <button type="submit" className="btn btn-primary">Submit</button><br />
                            <span style={{color: "red"}}>{this.state.api_error}</span>
                        </div>
                        </div>
                       {/* order summery */}
                       <div class="order-summary col-md-4" >
                        <div class="order-summary-inner">
                            <div class="order-summary-row plan-font-size pb-4">
                            <div class="order-label">
                                <small>Order Summary</small>
                            <h2>ACT Store Order</h2>
                          
                            </div>

                            <div class="summary-value pt-40">
                                {/* Demo 01 */}
                            </div>
                            </div>

                            <div class="order-summary-row">
                            <div class="order-label" style={{width:"150px"}}>
                            Items 
                            </div>
                            <div class="order-label">
                            Qty
                            </div>
                            <div class="order-label">                           
                            Amount
                            </div>
                            </div>

                            

                           

                                                
                            {(this.state.shippingLabel)?
                            <div class="order-summary-row">
                            <div class="order-label" style={{width:"167px"}}>
                            Shipping Label
                            </div>
                            <div class="summary-value">                           
                                {(this.state.formData['shippingLabel']['quantity'])}  
                            </div>
                            <div class="summary-value">                           
                                {/* {this.numberFormat(this.state.formData['shippingLabel']['price'])} */}
                                $0.00
                            </div>
                            </div>:""}

                           
                       
                            <div class="order-summary-row">
                            <div class="order-label">
                            Shipping Fee
                            </div>
                            <div class="summary-value">                           
                                {this.numberFormat(this.state.shipping)}
                                {/* <NumberFormat thousandSeparator={true} thousandsGroupStyle="lakh" prefix={'$'} value={this.state.shipping}/> */}
                            </div>
                            </div>

                            <div class="order-summary-row">
                            <div class="order-label">
                            Processing Fee
                            </div>
                            <div class="summary-value">                           
                                {this.numberFormat(this.state.formData['CreditCardProcessingFee'])}
                                {/* <NumberFormat thousandSeparator={true} thousandsGroupStyle="lakh" prefix={'$'} value={this.state.shipping}/> */}
                            </div>
                            </div>
                    

                        

                            <div class="order-summary-row total-saving">
                            <div class="order-label">
                            <i><img src="images/saving-icon.png" alt="" /></i>  Total Price 
                            </div>
                            <div class="summary-value">
                                {/* ${(this.state.amount)+(this.state.shipping)+(this.state.cpp_price)} */}

                                {(this.state.formData['minilipo']['price']> 0 || this.state.formData['stemskinserum']['price'] > 0 || this.state.shipping >0 )? 
                                this.numberFormat(this.state.amount+this.state.formData['CreditCardProcessingFee']+ this.state.shipping):
                                this.numberFormat(this.state.shipping)
                            }
                            </div>                      
                            </div>
                    
                            {/* <img style={{marginTop:"15px"}} className="card-logo" src="images/ACT Bloodwork Instructions.JPG" alt="" /> */}
                        </div>

                  
                  
                             </div>
                      
                        </div>                        
                        </form>
                        </div>
                        }
                        </div>

                </div>
            </MainLayout>
        );
    }
}

StemCellRequest.propTypes = {
    errors: PropTypes.object.isRequired,
    error: PropTypes.object.isRequired,
    setStoreRequest: PropTypes.object.isRequired,
    getPhysician: PropTypes.object.isRequired,
    getPaymentInfo: PropTypes.object.isRequired,
    GetPhysicianVialsService: PropTypes.object.isRequired,  
    getFedexShipQuote: PropTypes.object.isRequired,
    verifyAddressWithFedex:PropTypes.object.isRequired, 
    getShippingLabel: PropTypes.object.isRequired,
    verifyClientData:PropTypes.object.isRequired,
    getShippingUPSLabel:PropTypes.object.isRequired,


};

const mapStateToProps = (state) => ({
    page_name : state.pay,       
    errors: state.errors,
  });

  export default connect(mapStateToProps, {getPhysician,getPaymentInfo,setStoreRequest,GetPhysicianVialsService,verifyAddressWithFedex,getFedexShipQuote,getShippingLabel,verifyClientData,getShippingUPSLabel  })(StemCellRequest);


// export default StemCellRequest;